// Tech stack data for mobile app project
export const mobileAppTechStack = {
  'Core Technologies': [
    { name: 'React Native', description: 'v0.71.7 - Cross-platform mobile framework' },
    { name: 'TypeScript', description: 'For type-safe JavaScript development' },
  ],
  'State Management': [
    { name: 'Redux', description: 'For global state management' },
    { name: 'Redux Toolkit', description: 'Modern Redux utility library' },
    { name: 'React Query (TanStack Query)', description: 'For server state management with offline support' },
  ],
  Navigation: [
    { name: 'React Navigation', description: 'For screen navigation' },
    { name: 'Multiple navigation types', description: 'Stack, Bottom Tabs, and Material Top Tabs' },
  ],
  'UI Libraries': [
    { name: 'Native-X components', description: 'native-x-theme, native-x-stack, etc.' },
    { name: 'React Native Gesture Handler', description: 'For touch interactions' },
    { name: 'React Native Reanimated', description: 'For animations' },
    { name: 'React Native SVG', description: 'For vector graphics' },
    { name: 'React Native Maps', description: 'For maps integration' },
  ],
  'Networking & Data': [
    { name: 'Async Storage', description: 'For local data persistence' },
    { name: 'React Query persister', description: 'For offline data caching' },
    { name: 'SSL Pinning', description: 'For secure API communications' },
  ],
  'Device Features': [
    { name: 'React Native Permissions', description: 'For handling device permissions' },
    { name: 'React Native Image Crop Picker', description: 'For image selection and editing' },
    { name: 'React Native Camera/QR Code Scanner', description: 'For scanning functionality' },
    { name: 'React Native Geolocation Service', description: 'For location services' },
    { name: 'React Native File System (RNFS)', description: 'For file operations' },
    { name: 'React Native Document Picker', description: 'For selecting documents' },
  ],
  Internationalization: [{ name: 'i18next/react-i18next', description: 'For multilingual support' }],
  'Development Tools': [
    { name: 'ESLint', description: 'For code linting' },
    { name: 'Prettier', description: 'For code formatting' },
    { name: 'Jest', description: 'For testing' },
  ],
  'Other Notable Libraries': [
    { name: 'React Native Fast Image', description: 'For optimized image rendering' },
    { name: 'React Native PDF', description: 'For PDF viewing' },
    { name: 'React Native Modalize', description: 'For modal components' },
    { name: 'React Native Safe Area Context', description: 'For safe area handling' },
    { name: 'React Native Splash Screen', description: 'For custom splash screens' },
    { name: 'Notifee', description: 'For notification handling' },
  ],
};

// Tech stack data for web project
export const webAppTechStack = {
  'Frontend Framework': [
    { name: 'React 18', description: 'Core UI library for component-based architecture' },
    { name: 'TypeScript', description: 'For type-safe JavaScript development' },
  ],
  'State Management': [
    { name: 'Zustand', description: 'For global state management' },
    { name: 'React Query', description: 'For server state and data fetching' },
  ],
  'UI & Styling': [
    { name: 'Material UI (MUI v5)', description: 'Component library based on Material Design' },
    { name: 'Emotion', description: 'For CSS-in-JS styling' },
  ],
  Routing: [{ name: 'React Router v6', description: 'For application routing and navigation' }],
  'API Communication': [{ name: 'Axios', description: 'For HTTP requests and API integration' }],
  'Form Handling': [
    { name: 'React Hook Form', description: 'For form state management and validation' },
    { name: 'Yup', description: 'For schema-based form validation' },
  ],
  Internationalization: [{ name: 'i18next', description: 'For multilingual support' }],
  'Maps Integration': [{ name: 'Google Maps API', description: '@react-google-maps/api for maps functionality' }],
  'Data Visualization': [{ name: 'Chart.js', description: 'With react-chartjs-2 for interactive charts and graphs' }],
  'Notification Handling': [{ name: 'Notistack', description: 'For toast notifications and alerts' }],
  'Build & Development Tools': [
    { name: 'Create React App', description: 'For application scaffolding and configuration' },
    { name: 'TypeScript', description: 'With strict typing enabled' },
    { name: 'Prettier', description: 'For consistent code formatting' },
  ],
};

// Export other project tech stacks here if needed
export const techStacks = {
  mobileApp: mobileAppTechStack,
  webApp: webAppTechStack,
};
